// extracted by mini-css-extract-plugin
export default {"btn":"SubmitButton_btn__1lS4U","outlineBtn":"SubmitButton_outlineBtn__R30CK","touchbtn":"SubmitButton_touchbtn__336Co"};